module.exports = __webpack_public_path__ + "static/media/8.9d8a4cc1.jpg";